
import { createRadioBase } from 'JS/components/blain-form/BRadioBase';
import { defineComponent } from 'vue';

const { withRadioBaseProps, useRadioBase } = createRadioBase();

export default defineComponent({
	props: {
		...withRadioBaseProps(),
	},
	setup(props, { emit }) {
		return {
			...useRadioBase(props, emit),
		};
	}
});

